module.exports = __webpack_public_path__ + "static/img/tabela.831f4fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/guarana/tabela.png
// module id = 3Lae
// module chunks = 0